module.exports = __webpack_public_path__ + "g.no1.6db3e886.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/g.no1.jpg
// module id = keJP
// module chunks = 0